import { useQuery } from '@tanstack/react-query';
import { getAssignableRoles, getUsers } from '../requests/users.request';

export const usersKey = ['users'];

export const useUsersQuery = () =>
  useQuery({ queryKey: usersKey, queryFn: getUsers, refetchOnWindowFocus: false });

export const useAssignableRolesQuery = () =>
  useQuery({ queryKey: ['users', 'roles'], queryFn: getAssignableRoles, staleTime: Infinity });
